import pageStyles from "pages/BuildingPage/VirtualAudit/VirtualAuditPage.module.scss";
import styles from "./PropertyProjectsSection.module.scss";

interface ProjectsSkeletonTableProps {
    cols: ReadonlyArray<{ label: string; key: string }>;
}

function ProjectsSkeletonTable({ cols }: ProjectsSkeletonTableProps) {
    const skeletonRows = ["row-1", "row-2", "row-3", "row-4", "row-5"];

    return (
        <table className={styles.table}>
            <thead>
                <tr>
                    {cols.map((c) => (
                        <th key={c.key} className={styles.th}>
                            {c.label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {skeletonRows.map((rowKey) => (
                    <tr key={rowKey} className={styles.tr}>
                        {cols.map((c) => (
                            <td key={c.key} className={styles.td}>
                                <div className={pageStyles.skeletonCell} />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default ProjectsSkeletonTable;
